import Vue from 'vue'

export default {
  apiPrefix: '/api/v2/sites',
  getSites: function () {
    let apiDetailPath = this.apiPrefix
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  },
  getSite: function ({siteId}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  },
  // Owner Pre-Authorize toggles (CHEKT-2084). Partial update: send only the
  // changed pre_authorize_* keys (int 0/1). Owner-only (403 err_code 10403 for
  // non-owner). 200 returns all 5 keys merged.
  updateApprovalSettings: function ({siteId, changes}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/approval-settings`
    return Vue.http.put(Vue.env.apiPath + apiDetailPath, changes, Vue.auth.getBearerHeader())
  },
}
